import React, { useEffect, useState } from "react";
import Layout from "../components/Layout";
import PageTitle from "../components/PageTitle";
import { useDispatch, useSelector } from "react-redux";
import { addNews } from "../redux/actions/newsAction";
import { useNavigate } from "react-router-dom";
import { NEWS_ADD_RESET } from "../redux/constants/newsConstant";

const AddNewsScreen = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const newsAddState = useSelector((state) => state.newsAdd);
  const { success } = newsAddState;
  const [title, setTitle] = useState("");
  const [link, setLink] = useState("");
  const [description, setDescription] = useState("");
  const handleSubmitForm = (e) => {
    e.preventDefault();
    dispatch(addNews(title, link, description));
  };

  useEffect(() => {
    if (success) {
      navigate("/news");
      dispatch({ type: NEWS_ADD_RESET });
    }
  }, [success]);
  return (
    <Layout>
      <PageTitle title="Add New News" />
      <div className="card">
        <div className="card-body">
          <form onSubmit={handleSubmitForm}>
            <div className="row mb-3">
              <label htmlFor="name" className="col-sm-2 col-form-label">
                News Title
              </label>
              <div className="col-sm-10">
                <input
                  className="form-control"
                  type="text"
                  placeholder="Enter Title for News"
                  onChange={(e) => setTitle(e.target.value)}
                />
              </div>
            </div>
            <div className="row mb-3">
              <label
                htmlFor="example-week-input"
                className="col-sm-2 col-form-label"
              >
                Link For News
              </label>
              <div className="col-sm-10">
                <input
                  className="form-control"
                  type="text"
                  placeholder="Enter Link for News"
                  onChange={(e) => setLink(e.target.value)}
                />
              </div>
            </div>
            <div className="row mb-3">
              <label htmlFor="name" className="col-sm-2 col-form-label">
                News Description
              </label>
              <div className="col-sm-10">
                <textarea
                  className="form-control"
                  type="text"
                  rows={9}
                  placeholder="Enter Small Description For News"
                  onChange={(e) => setDescription(e.target.value)}
                ></textarea>
              </div>
            </div>

            <button type="submit" className="btn btn-primary">
              Add
            </button>
          </form>
        </div>
      </div>
    </Layout>
  );
};

export default AddNewsScreen;
